import { gql } from '@apollo/client';

export const GET_TASK_COUNT_BY_JOB_TYPE = gql`
  query getTaskCountByJobType($clientId: ID!, $status: JobStatus!) {
    jobTypeCount(jobTypeCountFilterInput: { clientId: $clientId, status: $status }) {
      jobType
      typeCount
    }
  }
`;
